import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme } from "../theme/toyotaTheme";
import { focusStyle } from "../utilities/Focus";

export const Step = styled.span.attrs(() => ({
    className: "t-base-headline",
}))<{ isActive?: boolean; noPadding?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.space[1]}px;
    margin-bottom: 0;
    font-family: ${theme.fonts.regular};
    font-size: 1.3rem;
    line-height: 1.9rem;
    text-align: center;
    color: ${theme.colors.primaryWhite};

    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.grey3};
            @media ${getBreakpoint("up", "lg")} {
                color: ${theme.colors.primaryWhite} !important;
            }
        `};
`;

export const StepText = styled.span`
    color: ${theme.colors.primaryWhite};
`;

export const StepWithoutLink = styled.div`
    cursor: default;
    @media ${getBreakpoint("up", "lg")} {
        padding-left: 45px;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "lg")} {
            padding-left: 0;
            padding-right: 45px;
        }
    }
`;

export const Icon = styled.span<{ isActive?: boolean }>`
    display: none;
    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        padding-bottom: 3px; /* To fix correct vertical alignment */
        font-family: ${theme.fonts.bold};
        font-size: 1.4rem;
        color: ${theme.colors.primaryWhite};
        background-color: ${theme.colors.grey5};
        border-radius: 90%;
        ${({ isActive }) =>
            isActive &&
            css`
                color: ${theme.colors.primaryBlack};
                background-color: ${theme.colors.primaryWhite};
            `};
    }
`;

export const Wrapper = styled.li<{ isActive?: boolean }>`
    display: flex;
    justify-content: center;
    margin-bottom: 0;
    background-color: ${theme.colors.primaryBlack};

    &::before {
        display: block;
        width: 12px;
        height: 2px;
        content: "";
        background-color: ${({ isActive }) => (isActive ? theme.colors.primaryWhite : theme.colors.grey3)};
    }

    a {
        text-decoration: none;
        ${focusStyle};
    }
`;
